import React from "react";
import classes from "./DropdownList.module.css";

const DropdownList = ({ children }) => {
  return <ul className={classes.list}>{children}</ul>;
};

export default DropdownList;
